import type { SVGProps } from "react";
import { Lightning } from "./Lightning";
import { Snowflake } from "./Snowflake";
import { Truck } from "./Truck";
import { CheckCircle } from "./CheckCircle";
import { ClipboardList } from "./ClipboardList";
import { Lock } from "./Lock";
import { Party } from "./Party";
import { Phone } from "./Phone";
import { Mail } from "./Mail";
import { MapPin } from "./MapPin";
import { Instagram } from "./Instagram";
import { Facebook } from "./Facebook";
import { Twitter } from "./Twitter";
import { LinkedIn } from "./LinkedIn";
import { Link } from "./Link";
import { Clock } from "./Clock";
import { Globe } from "./Globe";
import { Sparkles } from "./Sparkles";
import { School } from "./School";
import { Building } from "./Building";
import { Tent } from "./Tent";
import { Tool } from "./Tool";
import { Handshake } from "./Handshake";
import { Ear } from "./Ear";
import { Compass } from "./Compass";
import { HardHat } from "./HardHat";
import { ChartUp } from "./ChartUp";
import { Package } from "./Package";
import { Lightbulb } from "./Lightbulb";
import { Cake } from "./Cake";
import { Rocket } from "./Rocket";
import { Ribbon } from "./Ribbon";
import { Mountain } from "./Mountain";
import { Wave } from "./Wave";
import { Briefcase } from "./Briefcase";
import { Satellite } from "./Satellite";
import { Users } from "./Users";

export type IconName =
  | "lightning"
  | "snowflake"
  | "truck"
  | "check-circle"
  | "clipboard-list"
  | "lock"
  | "party"
  | "phone"
  | "mail"
  | "map-pin"
  | "instagram"
  | "facebook"
  | "twitter"
  | "linkedin"
  | "link"
  | "clock"
  | "globe"
  | "sparkles"
  | "school"
  | "building"
  | "tent"
  | "tool"
  | "handshake"
  | "ear"
  | "compass"
  | "hard-hat"
  | "chart-up"
  | "package"
  | "lightbulb"
  | "cake"
  | "rocket"
  | "ribbon"
  | "mountain"
  | "wave"
  | "briefcase"
  | "satellite"
  | "users";

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
}

const iconMap = {
  lightning: Lightning,
  snowflake: Snowflake,
  truck: Truck,
  "check-circle": CheckCircle,
  "clipboard-list": ClipboardList,
  lock: Lock,
  party: Party,
  phone: Phone,
  mail: Mail,
  "map-pin": MapPin,
  instagram: Instagram,
  facebook: Facebook,
  twitter: Twitter,
  linkedin: LinkedIn,
  link: Link,
  clock: Clock,
  globe: Globe,
  sparkles: Sparkles,
  school: School,
  building: Building,
  tent: Tent,
  tool: Tool,
  handshake: Handshake,
  ear: Ear,
  compass: Compass,
  "hard-hat": HardHat,
  "chart-up": ChartUp,
  package: Package,
  lightbulb: Lightbulb,
  cake: Cake,
  rocket: Rocket,
  ribbon: Ribbon,
  mountain: Mountain,
  wave: Wave,
  briefcase: Briefcase,
  satellite: Satellite,
  users: Users,
};

export const iconNames = Object.keys(iconMap) as IconName[];

/**
 * Icon component that renders SVG icons by name.
 * All icons use currentColor and can be styled with text color utilities.
 */
export function Icon({ name, ...props }: IconProps) {
  const IconComponent = iconMap[name];
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  return <IconComponent {...props} />;
}
